import { render, staticRenderFns } from "./CuttingandpleatingPage.vue?vue&type=template&id=638c0446"
import script from "./CuttingandpleatingPage.vue?vue&type=script&lang=js"
export * from "./CuttingandpleatingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports